<template>
	<div>
		<div>
			<br/>
			<h2 class="text-success pt-3 bMikhak text-center" >
				پرمخاطب‌ترین‌ها
			</h2>
		</div>
		<div id="teacherSlider" class="w-100 p-3 border-15"
			style=""
		>
			<section
				class="customer-logos slider col-10 m-auto"
				style="height: 150;"
			>
				<VueSlickCarousel  v-bind="settings" >
					<div class="slide p-2" v-for="(d, j) in data"  :key="j" v-if="d.status==3 && d.title!=''">
						<a :href="d.link" >
							<div class="border-15" >
								<div class="text-center overflow-hidden" >
									<img
										:src="require('../../../assets/img/social_network/'+d.img)"
										:alt="d.title"
										:title="d.title"
										class="w-100 mb-3"
									/>

									<div class=" float-right text-success text-center w-100 aut12 w-70">
										{{d.title}}
									</div>
									<div class="w-100 float-right text-truncate rtl aut8">
										{{d.about_me}}
									</div>
								</div>
							</div>
						</a>
					</div>
				</VueSlickCarousel>
			</section>
			<div style="
				overflow: hidden;
				display: flex;
				align-content: center;
				justify-content: center;
				align-items: center;
				margin-top: 30px;
			">
				<btn
					text=""
					type=""
					shadow="0"
					imgSize="50"
					function="right"
					class="float-down col-1"
					style="display: flex; align-items: center; justify-content: center;"
					:img="img.ArrowBoxRight"
					@right="right()"
					v-if="windowWidth > 990"
				/>
				<btn
					text=""
					type=""
					shadow="0"
					imgSize="50"
					function="left"
					class="float-down col-1"
					style="display: flex; align-items: center; justify-content: center;"
					:img="img.ArrowBoxLeft"
					@left="left()"
					v-if="windowWidth > 990"
				/>
				
			</div>
	</div>
	</div>
</template>

	<script>
		import ArrowBoxRight from '../../../assets/img/Arrow_Box_Right.svg';
		import ArrowBoxLeft from '../../../assets/img/Arrow_Box_Left.svg';
		import VueSlickCarousel from 'vue-slick-carousel'
		import 'vue-slick-carousel/dist/vue-slick-carousel.css'
		import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
		import btn from  "../../../UI/button/btn.vue";
		import userImg from  "../../../UI/userImg/userImg.vue";
		export default {
			name: 'p_home4',
			data(){
				return {
					img: {
							"ArrowBoxRight": ArrowBoxRight,
							"ArrowBoxLeft": ArrowBoxLeft,
					},
					settings:{
						slidesToShow: 8,
						slidesToScroll: 1,
						autoplay: true,
						autoplay: true,
						autoplay: true,
						autoplaySpeed: 1500,
						arrows: true,
						dots: false,
						pauseOnHover: false,
						responsive: [{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						}, {
							breakpoint: 520,
							settings: {
								slidesToShow: 3
							}
						}],
						"centerPadding": "15px",
					}
				}
			},
			components: {
				btn,
				userImg,
				VueSlickCarousel,
				ArrowBoxRight,
				ArrowBoxLeft,
			},
			props: ["data"],
			mounted(){
			},
			methods:{
				left(){
					window.$(".slick-next").click();
				},
				right(){
					window.$(".slick-prev").click();
				}
			}
		}
	</script>
<style scope>
.aut{
	font-size: 15px;
}
.aut12{
	font-size: 12px;
}
.aut8{
	font-size: 8px;
}
.w-70{
	 width: 70%;
}
.rounded-circle {
    border-radius: 50% !important;
	}
</style>
